/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { compose } from "redux";
import CountryHeader from "./CountryHeader";
import MasterService from "../../services/MasterService";
import CountryService from "../../services/CountryService";
import "../../public/common.css";
import { GlobalLoading } from "react-global-loading";

class Country extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      categories: [],
      selectedCategory: "",
      countryId: props.match.params.id,
      countryName: props.match.params.country,
      document,
      responsive: {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
      },
    };
  }

  componentDidMount = () => {
    this.getAllCategories();
    this.getCountryDetails();
  };

  getCountryDetails = () => {
    CountryService.countryDetail({ 'blog_id': this.state.countryId })
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countryData: result[0] });
      })
      .catch(err => {
        console.error(err);
      });
  };

  getAllCategories = () => {
    MasterService.getCategories()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ categories: result, selectedCategory: result[0] });
      })
      .catch(err => {
        console.error(err);
      });
  };
  handleCallback = (childData) => {
    this.setState({ selectedCategory: childData });
  };
  render() {
    const {
      countryId,
      categories,
      selectedCategory,
      countryData,
      countryName,
      document,
    } = this.state;

    return (
      <>

        <CountryHeader parentCallback={this.handleCallback} />

        {/* below is the important links section */}
        <section className="pt-3 pb-5">
          <GlobalLoading />
          <div className="container">
            
            <div className="activityList">
            
                {(countryData?.rules_regulation || countryData?.rules_regulation_upload) && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button acbor"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          Rules &amp; regulation for Trademark in {countryName}
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {countryData?.rules_regulation}
                        </div>
                        {/* below is the pdf row */}
                        <div className="pdfrw">
                          {countryData.rules_regulation_upload && <div className="pdbtns">
                            <svg
                              fill="#000000"
                              viewBox="-274.15 0 1200 1200"
                              xmlns="http://www.w3.org/2000/svg"
                              class="cf-icon-svg svwd"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M30 161c-16.5 0-30 13.5-30 30v827.8c0 16.5 13.5 30 30 30h591.7c16.5 0 30-13.5 30-30V343.7L469 161H30zm389.6 60v134.8c0 19.9 16.3 36.2 36.2 36.2h135.9v596.8H60V221h359.6z"></path>
                                <path d="M123.8 768.6h394.8v50H123.8zm0-124.6h394.8v50H123.8zm0-124.5h394.8v50H123.8z"></path>
                                <circle cx="194" cy="382.3" r="60"></circle>
                              </g>
                            </svg>
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#docModal"
                            >
                              <span
                                className="dpsn"
                                onClick={() =>
                                  this.setState({
                                    document:
                                      countryData.rules_regulation_upload,
                                  })
                                }
                              >
                                View Pdf
                              </span>
                            </div>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}

                <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <Link
                          to={{
                            pathname:
                              "/country-users/" +
                              countryId +
                              "/" +
                              selectedCategory.name,
                          }}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>                            
                            {selectedCategory.name} Practitioners in {countryName}
                          </span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            // xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </Link>
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <Link
                          to={{
                            pathname:
                              "/country-products/" +
                              countryId +
                              "/" +
                              selectedCategory.name,
                          }}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>
                            {" "}
                            {selectedCategory.name} Products / OTC (Over the
                            counter) in {countryName}
                          </span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            // xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </Link>
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <Link
                          to={{
                            pathname:
                              "/country-events/" +
                              countryId +
                              "/" +
                              selectedCategory.name,
                          }}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>
                            {" "}
                            {selectedCategory.name} events in {countryName}
                          </span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            // xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </Link>
                      </h2>
                    </div>
                  </div>
                </div>
                {(countryData?.mou || countryData?.mou_upload) && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button acbor"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Details of MoU's between India &amp; {countryName}.
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">{countryData?.mou}</div>
                        {/* below is the pdf row */}
                        {countryData?.mou_upload && <div className="pdfrw">
                          <div className="pdbtns">
                            <svg
                              fill="#000000"
                              viewBox="-274.15 0 1200 1200"
                              xmlns="http://www.w3.org/2000/svg"
                              class="cf-icon-svg svwd"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M30 161c-16.5 0-30 13.5-30 30v827.8c0 16.5 13.5 30 30 30h591.7c16.5 0 30-13.5 30-30V343.7L469 161H30zm389.6 60v134.8c0 19.9 16.3 36.2 36.2 36.2h135.9v596.8H60V221h359.6z"></path>
                                <path d="M123.8 768.6h394.8v50H123.8zm0-124.6h394.8v50H123.8zm0-124.5h394.8v50H123.8z"></path>
                                <circle cx="194" cy="382.3" r="60"></circle>
                              </g>
                            </svg>
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#docModal"
                            >
                              <span
                                className="dpsn"
                                onClick={() =>
                                  this.setState({
                                    document: countryData.mou_upload,
                                  })
                                }
                              >
                                View Pdf
                              </span>
                            </div>
                          </div>
                        </div>}
                      </div>
                    </div>
                  </div>
                </div>}

                <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <Link
                          to={{
                            pathname:
                              "/country-documents/" +
                              countryId +
                              "/" +
                              selectedCategory.name,
                          }}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>
                            {" "}
                            {selectedCategory.name} Documents in {countryName}
                          </span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            // xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </Link>
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <Link
                          to={{
                            pathname:
                              "/country-centers/" +
                              countryId +
                              "/" +
                              selectedCategory.name,
                          }}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>
                            {" "}
                            {selectedCategory.name} Centers in {countryName}
                          </span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            // xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </Link>
                      </h2>
                    </div>
                  </div>
                </div>
                {(countryData?.info_cell || countryData?.info_cell_upload) && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button acbor"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Ayush Information cell in {countryName}.
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {countryData?.info_cell}
                        </div>
                        {/* below is the pdf row */}
                        <div className="pdfrw">
                          {countryData.info_cell_upload && <div className="pdbtns">
                            <svg
                              fill="#000000"
                              viewBox="-274.15 0 1200 1200"
                              xmlns="http://www.w3.org/2000/svg"
                              class="cf-icon-svg svwd"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M30 161c-16.5 0-30 13.5-30 30v827.8c0 16.5 13.5 30 30 30h591.7c16.5 0 30-13.5 30-30V343.7L469 161H30zm389.6 60v134.8c0 19.9 16.3 36.2 36.2 36.2h135.9v596.8H60V221h359.6z"></path>
                                <path d="M123.8 768.6h394.8v50H123.8zm0-124.6h394.8v50H123.8zm0-124.5h394.8v50H123.8z"></path>
                                <circle cx="194" cy="382.3" r="60"></circle>
                              </g>
                            </svg>{" "}
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#docModal"
                            >
                              <span
                                className="dpsn"
                                onClick={() =>
                                  this.setState({
                                    document: countryData.info_cell_upload,
                                  })
                                }
                              >
                                View Pdf
                              </span>
                            </div>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
                {(countryData?.opportunity || countryData?.opportunity_upload) && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button acbor"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Opportunities for students in {countryName}.
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {countryData?.opportunity}
                        </div>
                        {/* below is the pdf row */}
                        <div className="pdfrw">
                          {countryData.opportunity_upload && <div className="pdbtns">
                            <svg
                              fill="#000000"
                              viewBox="-274.15 0 1200 1200"
                              xmlns="http://www.w3.org/2000/svg"
                              class="cf-icon-svg svwd"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M30 161c-16.5 0-30 13.5-30 30v827.8c0 16.5 13.5 30 30 30h591.7c16.5 0 30-13.5 30-30V343.7L469 161H30zm389.6 60v134.8c0 19.9 16.3 36.2 36.2 36.2h135.9v596.8H60V221h359.6z"></path>
                                <path d="M123.8 768.6h394.8v50H123.8zm0-124.6h394.8v50H123.8zm0-124.5h394.8v50H123.8z"></path>
                                <circle cx="194" cy="382.3" r="60"></circle>
                              </g>
                            </svg>{" "}
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#docModal"
                            >
                              <span
                                className="dpsn"
                                onClick={() =>
                                  this.setState({
                                    document: countryData.opportunity_upload,
                                  })
                                }
                              >
                                View Pdf
                              </span>
                            </div>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
                {(countryData?.ayush_chair || countryData?.ayush_chair_upload) && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button acbor"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Ayush Chairs in {countryName}.
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {countryData?.ayush_chair}
                        </div>
                        {/* below is the pdf row */}
                        <div className="pdfrw">
                          {countryData.ayush_chair_upload && <div className="pdbtns">
                            <svg
                              fill="#000000"
                              viewBox="-274.15 0 1200 1200"
                              xmlns="http://www.w3.org/2000/svg"
                              class="cf-icon-svg svwd"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M30 161c-16.5 0-30 13.5-30 30v827.8c0 16.5 13.5 30 30 30h591.7c16.5 0 30-13.5 30-30V343.7L469 161H30zm389.6 60v134.8c0 19.9 16.3 36.2 36.2 36.2h135.9v596.8H60V221h359.6z"></path>
                                <path d="M123.8 768.6h394.8v50H123.8zm0-124.6h394.8v50H123.8zm0-124.5h394.8v50H123.8z"></path>
                                <circle cx="194" cy="382.3" r="60"></circle>
                              </g>
                            </svg>{" "}
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#docModal"
                            >
                              <span
                                className="dpsn"
                                onClick={() =>
                                  this.setState({
                                    document: countryData.ayush_chair_upload,
                                  })
                                }
                              >
                                View Pdf
                              </span>
                            </div>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
                {countryData?.links && <div className="container accordianspacing">
                  <div class="accordion" id="accordionExample_green">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <a href={countryData?.links}
                          class="acbor_grn acb_link"
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target="#collapseTwo"
                          aria-expanded="false"
                        // aria-controls="collapseTwo"
                        >
                          <span>Important links</span>
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            width={"20px"}
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                        </a>
                      </h2>
                    </div>
                  </div>
                </div>}
             
            </div>
          </div>
        </section>

        <div
          className="modal fade"
          id="docModal"
          tabIndex="-1"
          aria-labelledby="docapprovalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">
                  Document Details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">

                <div className="row mt-2 pdfht" aria-labelledby="#label1">
                  <object
                    id="#label1"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    data={document}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return { translation: state.translation };
};

export default compose(connect(mapStateToProps, null), withRouter)(Country);
